<template>
    <div class="album-container">
        <LoadingOverlay></LoadingOverlay>
    </div>
</template>

<script setup lang="ts">
import LoadingOverlay from "./LoadingOverlay.vue";
</script>
